export const isPwa = () => {
  return ['standalone'].some(
    (displayMode) => window.matchMedia('(display-mode: ' + displayMode + ')').matches
  )
}

export const isMobile = () => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
}
